module.exports = __webpack_public_path__ + "img/reserve.70c8cf5c.jpg";